import { Component, Inject, OnInit } from '@angular/core';
import { Types } from '@src/app/core/models/configuration.model';
import { ReactComponentData } from '@src/app/core/models/generic-models';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';
import { Summary, SummaryProps } from 'commercial-management--ancillaries--web-components-design--library';
import { IbCLinkPipe } from 'ib-web-commons/pipes';
import { AJSRootScope, CommonsSessionStorageService, downgradeToAJSComponent } from 'ib-web-commons/utils';

@Component({
    selector: 'ib-subscription-models-new-confirmation',
    templateUrl: './ib-subscription-models-new-confirmation.component.html',
    styleUrls: ['./ib-subscription-models-new-confirmation.component.scss']
})
export class IbSubscriptionModelsNewConfirmationComponent implements OnInit {

    passengerEmail: string;
    voucherCode: string;
    twitterLink: string;


    public summaryComponent: ReactComponentData<SummaryProps> = {
        component: Summary,
        props: {} as SummaryProps
    };

    constructor (
        private commonsSessionStorageService: CommonsSessionStorageService,
        @Inject(AJSRootScope) protected rootScope: CommonsRootScope,
        private ibCLinkPipe: IbCLinkPipe

    ) {

    }
    ngOnInit (): void {
        this.getData();
        this.getSummary();
    }

    getData (): void {
        const issueOrderInfo = this.commonsSessionStorageService.get<any>('issueOrderInfo');
        this.voucherCode = issueOrderInfo?.data.voucher.code;
        const sessionStorageConfigInfo = this.commonsSessionStorageService.get<Types.ConfigurationModel>(subscriptionModelsAppConstant.SESSION_STORAGE.CONFIGURATION_INFO);
        this.passengerEmail = sessionStorageConfigInfo.body.mainPassenger.email;
        this.twitterLink = this.ibCLinkPipe.transform('TWITTER_LINK');
    }

    getSummary (): void {
        this.summaryComponent.props = this.commonsSessionStorageService.get(subscriptionModelsAppConstant.SESSION_STORAGE.SUMMARY);
    }

}

downgradeToAJSComponent('ibSubscriptionModelsNewConfirmation', {
    component: IbSubscriptionModelsNewConfirmationComponent,
    inputs: []
}, 'ib-subscription-models-new-confirmation');
